/**
 * 财务模块通用业务代码
 */

import { GlobalManager } from '@/context'
import { UploadPayload } from '@/components/business-components/upload'
import { apiFinanceWithdrawPutPay } from '@/api/finance'
import { processUploadError } from '@/components/business-components/upload/utils'
import { useI18n } from '@/i18n'
import to from 'await-to-js'

export class FinanceShared {
  /**
   * 上传图片到存储桶
   * @param param0
   * @returns
   */
  static handleUpload({
    file,
    error
  }: UploadPayload): Promise<[File | undefined, string | undefined]> {
    return new Promise((res) => {
      if (error) {
        processUploadError(error)
        res([undefined, undefined])
        return
      }

      const reader = new FileReader()
      // 读取完毕后获取结果
      reader.onload = (event) => {
        const previewUrl = event?.target?.result?.toString() ?? ''
        res([file, previewUrl])
      }
      // 把文件对象作为一个 dataURL 读入
      reader.readAsDataURL(file!)
    })
  }

  /**
   * 上传图片到后台
   * @returns
   */
  static async uploadImage(file?: File) {
    const { t } = useI18n()
    if (!file) {
      GlobalManager.Modal.message({
        type: 'error',
        content: t('lobby.finance.withdraw.add.fileNull')
      })
      return undefined
    }
    const formData = new FormData()
    formData.append('uploadfile', file)
    const [err, data] = await to(apiFinanceWithdrawPutPay(formData))
    if (err) {
      return undefined
    }
    return data.data.data?.successLinks[0] ?? ''
  }
}
